<template>
    <v-card class="speaker-session-card elevation-0">
        <p class="speaker-session-card__title mb-1 px-4" :style="{color: titleColor}">
            {{ session.events_agenda_text }}
        </p>
        <p class="speaker-session-card__event-title px-4 mb-2">
            <v-icon class="speaker-session-card__event-icon mr-2" size="16">
                mdi-calendar-month
            </v-icon>
            <span class="speaker-session-card__event-text">
                {{ session.event.event_title }}
            </span>
        </p>
        <p class="speaker-session-card__event-date px-4 mb-1" :style="{ color: titleColor }">
            {{ formatDateRange(session.events_agenda_from, session.events_agenda_to) }}
        </p>
        <div
			v-for="{ track_color, track_id, track_name } in session.tracks"
			:key="track_id"
			class="d-flex align-center px-4 mb-1"
			:style="`color: ${track_color}`"
		>
			<v-icon :color="track_color" dark size="10" style="margin: 0 3px;"> mdi-circle</v-icon>
            <span class="speaker-session-card__event-track ml-2">{{ track_name }}</span>
		</div>
        <p class="speaker-session-card__event-location px-4 mb-0" v-if="session.session_location">
            <v-icon class="speaker-session-card__event-location-icon mr-2" size="16">mdi-map-marker</v-icon>
            {{ session.session_location }}
        </p>
    </v-card>
</template>

<script>
export default {
    props: {
        session: {
            type: Object,
            default: () => {}
        },
        type: {
            type: String,
            default: ''
        }
    },
    methods: {
        formatDateRange(dateFrom, dateTo) {
            const options = {
                weekday: 'long',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true,
            }

            //Convert Unix timestamps to JavaScript Date objects
            const fromDate = new Date(dateFrom * 1000)
            const toDate = new Date(dateTo * 1000)

            // Format the dates
            const formattedFromDate = fromDate.toLocaleString('en-US', options)
            const formattedToDate = toDate.toLocaleTimeString('en-US', options)

            // Construct the formatted date range string
            return `${formattedFromDate} - ${formattedToDate}`
        }
    },
    computed: {
        titleColor() {
            return this.type === 'future' ? '#4A4A4A' : '#9B9B9B'
        }
    }
}
</script>

<style lang="scss">
.speaker-session-card {
    width: 100%;
    border-radius: 12px !important;
    padding: 12px 0 !important;
    margin-bottom: 12px;
    border: 1px solid #E2E2E2 !important;
    background-color: #FBFBFB !important;

    &__title {
        font-size: 14px;
        font-weight: 700;
        line-height: 17px;
        overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
    }

    &__event {
        &-title {
            display: flex;
            align-items: center;
        }

        &-text {
            font-size: 14px;
            color: #4A4A4A;
            line-height: 20px;
        }

        &-icon {
            color: #8E8E93 !important;
        }

        &-date {
            font-size: 14px;
            font-weight: 600;
            line-height: 17px;
        }

        &-location {
            display: flex;
            align-items: center;
            color: #9B9B9B;
            font-size: 13px;
            font-weight: 600;
            line-height: 17px;
            word-break: break-word;

            &-icon {
                color: #9B9B9B !important;
            }
        }

        &-track {
            font-size: 13px;
            font-weight: 700;
            line-height: 15.85px;
        }
    }
}
</style>